import { createNavigationContainerRef } from "@react-navigation/native"
import { RootStackParamList } from "../router/types.ts"

export const navigationRef = createNavigationContainerRef<RootStackParamList>()

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function navigate(name: keyof RootStackParamList, params: any) {
  if (navigationRef.isReady()) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    navigationRef.navigate(name, params)
  }
}

export function navigateOnSessionExpired() {
  if (!navigationRef.isReady()) {
    return
  }

  const state = navigationRef.getRootState()
  if (!state) {
    return
  }

  const routeNames =
    "routeNames" in state && Array.isArray(state.routeNames)
      ? state.routeNames
      : state.routes.map((route) => route.name)

  if (routeNames.includes("LoggedOut")) {
    navigationRef.navigate("LoggedOut")
    return
  }

  if (routeNames.includes("LogIn")) {
    navigationRef.navigate("LogIn")
  }
}
